/**
 * Parses a .bstr (Booster export) file.
 *
 * File content format (line-based):
 *   Line 1: blank
 *   Line 2: dot phrase name (e.g. ".albut")
 *   Lines 3..N-2: full text content (may contain {Lbreak} for line breaks)
 *   Line N-1: author (ignored)
 *   Line N: timestamp (ignored)
 *
 * The filename also encodes metadata as key=value pairs separated by semicolons,
 * including a Desc field that may provide keywords when non-empty.
 */

function parseFilenameMetadata(filename) {
    const baseName = filename.replace(/\.bstr$/i, "");
    const result = {};
    const regex = /(\w+)\s*=\s*/gi;
    const positions = [];
    let m;
    while ((m = regex.exec(baseName)) !== null) {
      positions.push({
        key: m[1].toLowerCase(),
        valueStart: m.index + m[0].length,
      });
    }
    for (let i = 0; i < positions.length; i++) {
      const start = positions[i].valueStart;
      const end =
        i + 1 < positions.length
          ? baseName.lastIndexOf(";", positions[i + 1].valueStart)
          : baseName.length;
      result[positions[i].key] = baseName.substring(start, end === -1 ? baseName.length : end).trim();
    }
    return result;
  }
  
  export function parseBstrFile(content, filename) {
    const lines = content.split(/\r?\n/);
  
    const nonEmptyLines = lines
      .map((line, idx) => ({ line: line.trim(), idx }))
      .filter((entry) => entry.line.length > 0);
  
    const firstLine = nonEmptyLines.length > 0 ? nonEmptyLines[0].line : "";
    const filenameMeta = parseFilenameMetadata(filename);
  
    let dotPhrase = "";
    if (firstLine.startsWith(".")) {
      dotPhrase = firstLine;
    } else if (filenameMeta.dotphrase && filenameMeta.dotphrase.startsWith(".")) {
      dotPhrase = filenameMeta.dotphrase;
    }
  
    let fulltext = "";
    if (nonEmptyLines.length > 2) {
      let contentLines = nonEmptyLines.slice(1, -2);
      while (dotPhrase && contentLines.length > 0 && contentLines[0].line === dotPhrase) {
        contentLines = contentLines.slice(1);
      }
      fulltext = contentLines
        .map((entry) => entry.line)
        .join("\n")
        .replace(/\{Lbreak\}/gi, "\n")
        .trim();
    } else if (nonEmptyLines.length === 2) {
      fulltext = "";
    }
  
    const desc = filenameMeta.desc || "";
  
    const keywords = desc
      ? desc
          .split(/\s+/)
          .filter((w) => w.length > 0)
          .join(", ")
      : "";
  
    return {
      dot_phrase: dotPhrase,
      keywords,
      content: fulltext,
      desc,
      source: filename,
    };
  }
  
  export function validateMacro(macro) {
    const issues = [];
    if (!macro.dot_phrase || !macro.dot_phrase.startsWith(".")) issues.push("dot_phrase");
    if (!macro.keywords) issues.push("keywords");
    if (!macro.content) issues.push("content");
    return issues;
  }
  
